import { render, staticRenderFns } from "./entrustChildInfo.vue?vue&type=template&id=38ab360a&scoped=true"
import script from "./entrustChildInfo.vue?vue&type=script&lang=js"
export * from "./entrustChildInfo.vue?vue&type=script&lang=js"
import style0 from "./entrustChildInfo.vue?vue&type=style&index=0&id=38ab360a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab360a",
  null
  
)

export default component.exports